import TimeClock from 'page/TimeClock';

export const timeclock = {
  path: '/app/timeclock',
  permission: 'roster' as 'roster',
  channel: 'roster',
  component: TimeClock,
};
